export interface NavItem {
  label: string;
  to: string;
  icon: string;
  end?: boolean;
  superOnly?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Principal', to: '/', icon: 'ri-dashboard-3-line', end: true },
  { label: 'Proyectos', to: '/proyectos', icon: 'ri-folders-line' },
  { label: 'Facturación', to: '/facturacion', icon: 'ri-file-list-3-line' },
  { label: 'Finanzas', to: '/finanzas', icon: 'ri-line-chart-line' },
  { label: 'Usuarios', to: '/usuarios', icon: 'ri-group-line', superOnly: true },
  { label: 'Configuración', to: '/configuracion', icon: 'ri-settings-3-line', superOnly: true },
];

export interface PageMeta {
  title: string;
  subtitle: string;
}

export function getPageMeta(pathname: string): PageMeta {
  if (pathname === '/' || pathname === '') {
    return { title: 'Principal', subtitle: 'Resumen general de proyectos' };
  }
  if (pathname.startsWith('/proyectos/nuevo')) {
    return { title: 'Nuevo proyecto', subtitle: 'Registro de un nuevo proyecto' };
  }
  if (/^\/proyectos\/[^/]+\/editar/.test(pathname)) {
    return { title: 'Editar proyecto', subtitle: 'Actualización de la información del proyecto' };
  }
  if (pathname.startsWith('/proyectos/')) {
    return { title: 'Detalle del proyecto', subtitle: 'Información completa del proyecto' };
  }
  if (pathname.startsWith('/proyectos')) {
    return { title: 'Proyectos', subtitle: 'Listado y seguimiento de proyectos' };
  }
  if (pathname.startsWith('/facturacion')) {
    return { title: 'Facturación', subtitle: 'Gestión de recibos y cobros' };
  }
  if (pathname.startsWith('/finanzas')) {
    return { title: 'Finanzas', subtitle: 'Ingresos, egresos y saldo' };
  }
  if (pathname.startsWith('/usuarios')) {
    return { title: 'Usuarios', subtitle: 'Administración de usuarios y roles' };
  }
  if (pathname.startsWith('/configuracion')) {
    return { title: 'Configuración', subtitle: 'Información, estado y ajustes del sistema' };
  }
  return { title: 'Sistema de Seguimiento', subtitle: 'IZZY Corporation' };
}